import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import {Card} from './types';
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListItem from "../1. Core/Controls/ListBox/ListItem";
import Menu from "../1. Core/Controls/Menu/Menu";
import Dialog from "../1. Core/Controls/Dialog/Dialog";
import NumField from "../1. Core/Controls/TextField/NumField";


export default class CardList extends Control {
	private _topAppBar: TopAppBar;
	private EvShowPageModeClick: Delegate;

	private _dataTable: DataTable;
	private _dataWithFiltersNode: HTMLElement;
	private EvCardSelected: Delegate;
	private _ShowAppBar: boolean;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._ShowAppBar = true;
		this.EvCardSelected = new Delegate();
		this.EvShowPageModeClick = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('');


		if (this._ShowAppBar)
			this._topAppBar = new TopAppBar({
				Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
				Caption: 'Cards',
				ParentNode: this._root,
				ShowSearchButton: false,
				MainButton: {
					FontImage: NP.FontImages.menu,
					EvClick: () => this.EvShowPageModeClick.fire(this)
				}
			});

		this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowSettingsButton: NP.getCurrentUser().isBDAdmin(),
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: false,
			EnableSort: false,
			ImageWidth: 32,
			Columns: [{
				Content: 'Id',
				Width: '14%',
				PropertyContent: 'id'
			}, {
				Content: NP.RM.getString('Name'),
				PropertyContent: 'name',
				Width: '14%'
			}, {
				Width: '14%',
				Content: 'Time use',
				PropertyContent: 'timeuse'
			}, {
				Content: 'Сoef',
				PropertyContent: 'coef',
				Width: '14%'
			}, {
				Content: 'Gold сoef',
				PropertyContent: 'goldCoef',
				Width: '14%'
			}, {
				Content: 'Silver сoef',
				PropertyContent: 'silverCoef',
				Width: '14%'
			}, {
				Content: 'Bronze сoef',
				PropertyContent: 'bronzeCoef',
				Width: '14%'
			}],
			ShowPaginator: false,
			EvItemClick: (s: object, e: { Item: Card }) =>
			{
				this.EvCardSelected.fire(this, {Item: e.Item})
			},
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;


				this.refreshList();
			},
			EvItemContextMenu: async (s: any, e: { Event: any, Item: Card }) =>
			{
				if (!NP.getCurrentUser().isBDAdmin())
					return;

				let card = e.Item;

				let menu = new Menu({
					Items: [{
						FontImage: NP.FontImages.edit,
						RK: 'Edit',
						Value: 'Edit'
					}],
					EvItemSelected: async (s: Menu, event: { Item: ListItem }) =>
					{

						switch (event.Item.getValue())
						{
							case 'Edit':
								(new Dialog({
									Caption: card.name,
									ShowHeader: true,
									Content: [new NumField({
										FloatingLabel: 'Коэффициент',
										FractionCount: 2,
										Min: 1,
										Max: 5,
										Value: card.coef
									}), new NumField({
										FloatingLabel: 'Gold coef',
										FractionCount: 2,
										Min: 1,
										Max: 5,
										Value: card.goldCoef
									}), new NumField({
										FloatingLabel: 'Silver coef',
										FractionCount: 2,
										Min: 1,
										Max: 5,
										Value: card.silverCoef
									}), new NumField({
										FloatingLabel: 'bronze coef',
										FractionCount: 2,
										Min: 1,
										Max: 5,
										Value: card.bronzeCoef
									})],
									EvOkButtonClick: async (dlg: Dialog) =>
									{
										card.coef = dlg.getContent()[0].getValue()
										card.goldCoef = dlg.getContent()[1].getValue()
										card.silverCoef = dlg.getContent()[2].getValue()
										card.bronzeCoef = dlg.getContent()[3].getValue()
										await ServerAPI.post("/cards", card)
										this.refresh();
									}
								})).show()
								break;

						}
					}
				});
				menu.showContextMenu(e.Event);
			}
		});
	}


	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._Height - (this._topAppBar ? this._topAppBar.getOffsetHeight() : 0);
		this._dataTable.setHeight(h);

	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);
		if (this._dataTable.getIsSmall())
		{
			if (this._topAppBar)
				this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			if (this._topAppBar)
				this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
	}

	refresh()
	{
		this.refreshList();
	}

	private async refreshList()
	{
		let cards = await ServerAPI.get<Card[]>("/cards/items")

		this._dataTable.setRows(cards);
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}
}